import Vue from "vue"
import Vuex from "vuex"
import { deepCopy } from "../util/object.js"

Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        orderId: 0,
        consumerOrderId: 0,
        priority: 0,
        orderIdentificationTime: 0,
        orderExpiredAfter: 0,

        identifyingPersonalStats: {},

        videoIsPlaying: false,

        currentRate: "1.5",
        rateOptions: [
            { label: '1.5倍速', value: '1.5' },
            { label: '2倍速', value: '2' },
            { label: '2.5倍速', value: '2.5' },
            { label: '3倍速', value: '3' },
        ],

        currentException: "-1",
        exceptionOptions: [],

        orderVideoUrl: "",
        orderConsumerCommodities: [],
        orderCupboardCommodities: [],

        shoppingCommodities: {},

        orderNumber: 0,

        showHelpText: false,
        showInfoText: false,

        videoCurrentTime: "",
        videoDuration: "",

        restMoment: false,

        fetchingNewOrder: false,
    },
    getters: {
        orderId: state => {
            return state.orderId
        },
        consumerOrderId: state => {
            return state.consumerOrderId
        },
        priority: state => {
            return state.priority
        },
        playerIsPlaying: state => {
            return state.videoIsPlaying
        },
        playerCurrentRate: state => {
            return state.currentRate
        },
        playerRateOptions: state => {
            return state.rateOptions
        },
        orderVideoUrl: state => {
            return state.orderVideoUrl
        },
        orderConsumerCommodities: state => {
            return state.orderConsumerCommodities
        },
        orderCupboardCommodities: state => {
            return state.orderCupboardCommodities
        },
        shoppingCommodities: state => {
            return state.shoppingCommodities
        },
        orderNumber: state => {
            return state.orderNumber
        },
        exceptionOptions: state => {
            return state.exceptionOptions
        },
        currentException: state => {
            return state.currentException
        },
        showHelpText: state => {
            return state.showHelpText
        },
        showInfoText: state => {
            return state.showInfoText
        },
        restMoment: state => {
            return state.restMoment
        },
        videoCurrentTime: state => {
            return state.videoCurrentTime
        },
        videoDuration: state => {
            return state.videoDuration
        },
        orderIdentificationTime: state => {
            return state.orderIdentificationTime
        },
        orderExpiredAfter: state => {
            return state.orderExpiredAfter
        },
        identifyingPersonalStats: state => {
            return state.identifyingPersonalStats
        },
        fetchingNewOrder: state => {
            return state.fetchingNewOrder
        }
    },
    mutations: {
        playerPause(state) {
            state.videoIsPlaying = false
        },
        playerPlay(state) {
            state.videoIsPlaying = true
        },
        playerChangeRate(state, rate) {
            state.currentRate = rate
            console.log("playerChangeRate:", rate);
        },
        updateExceptionOptions(state, options) {
            state.exceptionOptions = options
        },
        updateExceptionOption(state, exception) {
            state.currentException = exception
        },
        changeOrderVideoUrl(state, url) {
            state.orderVideoUrl = url
        },
        changeOrderConsumerCommodities(state, commodities) {
            state.orderConsumerCommodities = commodities
        },
        changeOrderCupboardCommodities(state, commodities) {
            state.orderCupboardCommodities = commodities
        },
        changeShoppingCommodities(state, commodities) {
            state.shoppingCommodities = commodities
        },
        updateOrderId(state, orderId) {
            state.orderId = orderId
        },
        updateConsumerOrderId(state, consumerOrderId) {
            state.consumerOrderId = consumerOrderId
        },
        updatePriority(state, priority) {
            state.priority = priority
        },
        updateOrderNumber(state, number) {
            state.orderNumber = number
        },
        updateHelpStatus(state, isShow) {
            state.showHelpText = isShow
        },
        updateInfoStatus(state, isShow) {
            state.showInfoText = isShow
        },
        updateRestMoment(state, isRest) {
            state.restMoment = isRest
        },
        updateVideoCurrentTime(state, currentTime) {
            state.videoCurrentTime = currentTime
        },
        updateVideoDuration(state, duration) {
            state.videoDuration = duration
        },
        tickOrderIdentificationTime(state) {
            state.orderIdentificationTime = state.orderIdentificationTime + 1
        },
        resetOrderIdentificationTime(state) {
            state.orderIdentificationTime = 0
        },
        updateOrderExpiredAfter(state, expired) {
            state.orderExpiredAfter = expired
        },
        updateIdentifyingPersonalStats(state, stats) {
            state.identifyingPersonalStats = stats
        },
        updateFetchingNewOrder(state, fetching) {
            state.fetchingNewOrder = fetching
        },
        addCommodityInShoppingList(state, commodityId) {
            var consumerCommodities = state.orderConsumerCommodities
            var cupboardCommodities = state.orderCupboardCommodities
            var shoppingCommodities = state.shoppingCommodities

            var matchCommodity

            for (var i = 0; i < consumerCommodities.length; i++) {
                if (consumerCommodities[i].id == commodityId) {
                    consumerCommodities[i].number++

                    matchCommodity = deepCopy(consumerCommodities[i])
                    break
                }
            }

            if (!matchCommodity) {
                for (var i = 0; i < cupboardCommodities.length; i++) {
                    if (cupboardCommodities[i].id == commodityId) {
                        cupboardCommodities[i].number++

                        matchCommodity = deepCopy(cupboardCommodities[i])
                        break
                    }
                }
            }

            if (matchCommodity) {
                if (commodityId in shoppingCommodities) {
                    shoppingCommodities[commodityId].number++
                } else {
                    Vue.set(shoppingCommodities, commodityId, matchCommodity)
                }
            }

            var orderNumber = 0
            for (var key in shoppingCommodities) {
                orderNumber += shoppingCommodities[key].number
            }

            state.orderConsumerCommodities = consumerCommodities
            state.orderCupboardCommodities = cupboardCommodities
            state.shoppingCommodities = { ...shoppingCommodities }
            state.orderNumber = orderNumber
        },
        removeCommodityFromShoppingList(state, commodityId) {
            var consumerCommodities = state.orderConsumerCommodities
            var cupboardCommodities = state.orderCupboardCommodities
            var shoppingCommodities = state.shoppingCommodities

            var matchCommodity

            for (var i = 0; i < consumerCommodities.length; i++) {
                if (consumerCommodities[i].id == commodityId) {
                    if (consumerCommodities[i].number > 0) {
                        consumerCommodities[i].number--

                        matchCommodity = deepCopy(consumerCommodities[i])
                        break
                    }
                }
            }

            if (!matchCommodity) {
                for (var i = 0; i < cupboardCommodities.length; i++) {
                    if (cupboardCommodities[i].id == commodityId) {
                        if (cupboardCommodities[i].number > 0) {
                            cupboardCommodities[i].number--

                            matchCommodity = deepCopy(cupboardCommodities[i])
                            break
                        }
                    }
                }
            }

            if (matchCommodity) {
                if (commodityId in shoppingCommodities) {
                    shoppingCommodities[commodityId].number--

                    if (shoppingCommodities[commodityId].number <= 0) {
                        Vue.delete(shoppingCommodities, commodityId)  // 使用 Vue.delete 删除
                    }
                }
            }

            var orderNumber = 0
            for (var key in shoppingCommodities) {
                orderNumber += shoppingCommodities[key].number
            }

            state.orderConsumerCommodities = consumerCommodities
            state.orderCupboardCommodities = cupboardCommodities
            state.shoppingCommodities = { ...shoppingCommodities }
            state.orderNumber = orderNumber
        }
    }
})

export default store
